import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import {
  Button,
  Card,
  Flex,
  FormField,
  Page,
  TextInput,
} from '../../../components';
import api from '../../../utils/services';


const propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      carrierId: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

// TODO general error handleing
class NewRegion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
    };
  }

  handleChange = (event) => {
    const { target: { name, value } } = event;

    this.setState({
      [name]: value,
    });
  }

  handleSubmit = (event) => {
    event.preventDefault();

    const { history, match: { params: { carrierId } } } = this.props;
    api.addRegion({ ...this.state, carrierId })
      .then(() => {
        history.push(`/carriers/${carrierId}/plans/regions`);
      }).catch(() => {
        // TODO, display the error instead
        console.log('An error occurred. Please try again.');
      });
  }

  render() {
    const { name } = this.state;

    return (
      <Page title="Add Region">
        <Card>
          <Card.Block>
            <form onSubmit={this.handleSubmit}>
              <FormField
                label="Name"
                input={TextInput}
                name="name"
                value={name}
                onChange={this.handleChange}
              />
              <Flex paddingTop="1em">
                <Flex.Item marginStart="auto">
                  <Button primary type="submit">Save</Button>
                </Flex.Item>
              </Flex>
            </form>
          </Card.Block>
        </Card>
      </Page>
    );
  }
}

NewRegion.propTypes = propTypes;
export default withRouter(NewRegion);
